import { wsActionTypes, WSMessage } from 'shared';
import { WSMessageRejector, WSMessageResolver } from '../useWsToHttp';

export const giveUpHandler = (
  parsed: WSMessage<boolean>,
  resolve: WSMessageResolver<boolean>,
  reject: WSMessageRejector
): any => {
  switch (parsed.actionType) {
    case wsActionTypes.server.fight.giveUpS: {
      return resolve(true);
    }
    case wsActionTypes.server.fight.giveUpF: {
      return reject({
        // @ts-ignore
        error: parsed.data.error || parsed.data.message,
        status: parsed.status
      });
    }
  }
};
